/**
 * Renders an <img> for a dataset file URL (e.g. product/partner logo).
 * Fetches the image with API auth so it works when the URL is relative and the
 * page is served from a different origin than the API (e.g. app on 5003, API on 5100).
 */
import React from 'react';
import { useAuthenticatedDatasetImageUrl } from 'hooks/useAuthenticatedDatasetImageUrl';

export function AuthenticatedDatasetImage({ logoUrl, alt = '', className, style, ...imgProps }) {
  const { src, loading } = useAuthenticatedDatasetImageUrl(logoUrl || null);

  if (!logoUrl) return null;
  if (!src && !loading) return null;

  return (
    <img
      src={src || undefined}
      alt={alt}
      className={className}
      style={{ ...style, visibility: loading ? 'hidden' : 'visible' }}
      onError={(e) => { e.target.style.display = 'none'; }}
      {...imgProps}
    />
  );
}
